import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { getUser } from '../../reducers/auth';
import UserService from '../../services/user.service';
import OrderService from "../../services/order.service";
import { useForm } from "react-hook-form";

const AddressModal = (props) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name: props.address.name,
      street: props.address.street,
      street2: props.address.street2,
      city: props.address.city,
      state: props.address.state,
      zipCode: props.address.zipCode,
      id: props.address.id
    },
  });

  const onSubmit = async (data) => {
    var newAddress = await UserService.updateAddress(data);
    props.closeAddressModal(newAddress);
  }

  const addressModalClose = () => {
    props.closeAddressModal();
  }

  return (
    <Modal show={props.show} onHide={addressModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Address<br /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name</Form.Label>
            <input {...register("name", { required: true })} /><br />
            {errors.name && <div className="error" >Name is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="street">
            <Form.Label>Street</Form.Label>
            <input {...register("street", { required: true })} /><br />
            {errors.street && <div className="error" >Street is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="street2">
            <Form.Label>Apt/Suite Number</Form.Label>
            <input {...register("street2", { required: false })} /><br />
          </Form.Group>
          <Form.Group className="mb-3" controlId="city">
            <Form.Label>City</Form.Label>
            <input {...register("city", { required: true })} /><br />
            {errors.city && <div className="error" >City is required</div>}
          </Form.Group>
          <Form.Group className="mb-3" controlId="state">
            <Form.Label>State</Form.Label>
            <select
              name="state"
              {...register("state", { required: true })}
            >
              <option value="">Select a State</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            {errors.state?.type === 'required' && <div className="error" >State is required</div>}
          </Form.Group>

          <Form.Group className="mb-3" controlId="zipCode">
            <Form.Label>Zip Code</Form.Label>
            <input {...register("zipCode", { required: true, minLength: 5, maxLength: 10 })} /><br />

            {errors.zipCode?.type === 'required' && <div className="error" >Zip Code is required</div>}
            {(errors.zipCode?.type === 'minLength' || errors.zipCode?.type === 'maxLength') && <div className="error" >Zip Code should be 5 or 10 digits</div>}

          </Form.Group>
          <Modal.Footer>
            <Button variant="secondary" onClick={addressModalClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
              Update Address
            </Button>
          </Modal.Footer>
        </Form>


      </Modal.Body>
    </Modal >
  );
};

export default AddressModal; 